export function Accordion(el, id) {
  const link = el.querySelector(".js-accordion-link");
  const content = el.querySelector(".js-accordion-content");
  if (!link || !content) return false;

  const contentWrapper = wrap(content, document.createElement("div"));
  contentWrapper.classList.add("accordion-wrapper");

  // Optional: allow per-instance default via data attribute
  // <div class="js-accordion" data-accordion-default="open">...</div>
  const wantsDefaultOpen = el.getAttribute("data-accordion-default") === "open";

  // Experience editor forces open
  const editorView = document.querySelector("body.is-page-editor");

  const animationSpeed = 500;
  let contentBuffer = setTimeout(() => {}, 1);

  // Initialize expanded state from DOM flags
  let expanded = !!editorView || el.classList.contains("is-open") || wantsDefaultOpen;

  // Ensure proper initial paint
  if (expanded) {
    // Make sure host element reflects open state
    el.classList.add("is-open");
    // Ensure wrapper shows content immediately
    contentWrapper.style.visibility = "visible";
    setHeight(contentWrapper, "auto");
  } else {
    setHeight(contentWrapper, "0px");
  }

  // ARIA wiring
  link.setAttribute("aria-expanded", String(expanded));
  link.setAttribute("id", `accordion-link-${id}`);
  link.setAttribute("aria-controls", `accordion-content-${id}`);
  contentWrapper.setAttribute("id", `accordion-content-${id}`);

  if (editorView === null) {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      toggleContent(!expanded);
    });
  }

  function toggleContent(openState) {
    if (openState === expanded) return;

    const height = content.scrollHeight;
    expanded = openState;
    link.setAttribute("aria-expanded", String(openState));
    clearTimeout(contentBuffer);

    if (openState) {
      el.classList.add("is-open");
      contentWrapper.style.visibility = "visible";
      setHeight(contentWrapper, `${height}px`);
      contentBuffer = setTimeout(() => {
        setHeight(contentWrapper, "auto");
        contentWrapper.style.overflow = "visible";
      }, animationSpeed + 20);
    } else {
      el.classList.remove("is-open");
      setHeight(contentWrapper, `${height}px`);
      setTimeout(() => setHeight(contentWrapper, "0"), 20);
      setTimeout(() => { contentWrapper.style.visibility = "hidden"; }, animationSpeed + 20);
    }
  }

  function setHeight(elm, height) {
    elm.setAttribute(
      "style",
      `height: ${height}; transition: height ${animationSpeed}ms ease; overflow: hidden;`
    );
  }

  function wrap(elm, wrapper) {
    elm.parentNode.insertBefore(wrapper, elm);
    wrapper.appendChild(elm);
    return wrapper;
  }

  return { el, toggleContent };
}
